/* 🤖 this file was generated by svg-to-ts */
export const siriusBookmarkSimple: {
  name: 'bookmark_simple';
  data: string;
} = {
  name: 'bookmark_simple',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.69 3.44A1.5 1.5 0 0 1 6.75 3h10.5a1.5 1.5 0 0 1 1.5 1.5V21a.75.75 0 0 1-1.148.636L12 18.134l-5.603 3.502A.75.75 0 0 1 5.25 21V4.5c0-.398.158-.78.44-1.06ZM17.25 4.5H6.75v15.147l4.852-3.033a.75.75 0 0 1 .796 0l4.852 3.033V4.5Z" fill="currentColor"/></svg>`
};
